import React from "react";
import { useEffect, useState } from "react";
import {
  GetAllHoldCandidates,
  InterviewSchedule,
  SelectedCandidate,
  RejectedCandidates,
  viewResumeUrl,
  SystemRemark,
  BackOutCandidate
} from "../../../services/candidateService";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Modal, Button, Form, Toast, ToastContainer } from "react-bootstrap";
import NormalAlert from "../../AlertComponent/NormalAlert";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const GetHoldCandidate = () => {
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [remark, setRemark] = useState("");
  const [interviewID, setinterviewID] = useState("");
  const [interviewDateTime, setinterviewDateTime] = useState("");
  // const [endDate, setendDate] = useState();
  // const [endTime, setendTime] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [showJobTitleFilter, setShowJobTitleFilter] = useState(false);
  const [filteredTitles, setFilteredTitles] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [searchTitleText, setSearchTitleText] = useState("");
  const [status, setStatus] = useState("");
  const [submittedCandidateID, setSubmittedCandidateID] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [systemRemarkData, setSystemRemarkData] = useState(null);
  const [showSystemRemarkModal, setShowSystemRemarkModal] = useState(false);
  const [showSystemRemark, setShowSystemRemark] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "success",
  });
  const totalRecords = candidates.length;

  useEffect(() => {
    const GetHoldCandidates = async () => {
      try {
        const response = await GetAllHoldCandidates();

        if (
          response?.data?.status === "Success" &&
          response?.data?.holdCandidates
        ) {
          setCandidates(response.data.holdCandidates);
        } else {
          setAlert({
            type: "fail",
            message: response?.data?.message || "No hold candidates found.",
          });
          setCandidates([]);
        }
      } catch (error) {
        const backendMessage = error?.response?.data?.message;

        if (backendMessage !== "No candidate found.") {
          setAlert({
            type: "fail",
            message:
              backendMessage || "Something went wrong. Please try again.",
          });
        }

        setCandidates([]);
      } finally {
        setLoading(false);
      }
    };

    GetHoldCandidates();
  }, []);

  const openModal = (candidate, type) => {
    setSelectedCandidate(candidate);
    setModalType(type);
    setRemark("");
    setShowModal(true);
  };

  const jobTitles = [...new Set(candidates.map((c) => c.jobTitel))];

  const handleFilterIconClick = () => {
    setShowJobTitleFilter(true);
    setFilteredTitles(jobTitles);
    setSelectedTitles(jobTitles);
    setSearchTitleText("");
  };

  const handleSearchTitleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTitleText(value);
    setFilteredTitles(
      jobTitles.filter((title) => title.toLowerCase().includes(value))
    );
  };

  const handleSelectTitle = (title) => {
    if (selectedTitles.includes(title)) {
      setSelectedTitles(selectedTitles.filter((t) => t !== title));
    } else {
      setSelectedTitles([...selectedTitles, title]);
    }
  };

  const handleSelectAllTitles = (checked) => {
    setSelectedTitles(checked ? jobTitles : []);
  };

  const filteredCandidates = candidates.filter(
    (candidate) =>
      (selectedTitles.length === 0 ||
        selectedTitles.includes(candidate.jobTitel)) &&
      [
        candidate.name,
        candidate.jobTitel,
        candidate.email,
        candidate.mobile,
        candidate.submitedBy,
        candidate.submitByType,
      ].some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const hasCandidates = candidates.length > 0;
  const hasFilteredCandidates = filteredCandidates.length > 0;

  const [currentPage, setCurrentPage] = useState(1);
  const [candidatesPerPage, setCandidatesPerPage] = useState(10);
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = filteredCandidates.slice(
    indexOfFirstCandidate,
    indexOfLastCandidate
  );
  const totalPages = Math.ceil(filteredCandidates.length / candidatesPerPage);
  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  const goToNext = () =>
    currentPage < totalPages && setCurrentPage((prev) => prev + 1);
  const goToPrev = () => currentPage > 1 && setCurrentPage((prev) => prev - 1);
  const formatCurrentDateTime = (dateObj) => {
    const formattedDate = `${dateObj.getFullYear()}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${String(dateObj.getDate()).padStart(2, "0")}`;
    const formattedTime = `${String(dateObj.getHours()).padStart(
      2,
      "0"
    )}:${String(dateObj.getMinutes()).padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  };

  const formatStartDateTime = (dateString, timeString) => {
    if (!dateString || !timeString) {
      return "";
    }

    // Combine dateString and timeString into a Date object
    const [year, month, day] = dateString.split("-");
    const [hours, minutes] = timeString.split(":");
    const dateObj = new Date(year, month - 1, day, hours, minutes);

    // Format the date and time into dd/mm/yy hh:mm:ss
    const formattedDate = `${dateObj.getFullYear()}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${String(dateObj.getDate()).padStart(2, "0")}`;
    const formattedTime = `${String(dateObj.getHours()).padStart(
      2,
      "0"
    )}:${String(dateObj.getMinutes()).padStart(2, "0")}`;

    return `${formattedDate} ${formattedTime}`;
  };

  const HandleInterviewScheduleCandidate = () => {
    const Action = async () => {
      try {
        const formattedDateTime = interviewDateTime + ":00";

        const response = await InterviewSchedule(
          selectedCandidate.submitedCandidateUID,
          3,
          remark,
          interviewID,
          formattedDateTime
        );

        if (response) {
          setAlert({ type: response.data.status, message: response.message });
          setShowModal(false);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({
          type: "fail",
          message: error?.response?.data?.message || "Unknown error",
        });
      }
    };
    Action();
  };

  //  For Selected Canidate
  const HandleselectCandidate = () => {
    const Action = async () => {
      try {
        const response = await SelectedCandidate(
          selectedCandidate.submitedCandidateUID,
          5,
          remark
        );
        if (response) {
          setAlert({ type: response.data.status, message: response.message });
          setShowModal(false);
          console(response.data);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({ type: "fail", message: error.response.data.message });
      }
    };
    Action();
  };

  // For Rejected Candidate
  const HandleRejectedCandidate = () => {
    const Action = async () => {
      try {
        const response = await RejectedCandidates(
          selectedCandidate.submitedCandidateUID,
          7,
          remark
        );
        if (response) {
          setAlert({ type: response.data.status, message: response.message });
          setShowModal(false);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({ type: "fail", message: error.response.data.message });
      }
    };
    Action();
  };

  // For Back out Candidate
	const HandleBackoutCandidate = () => {
	  const Action = async () => {
		try {
		  const response = await BackOutCandidate(
			selectedCandidate.submitedCandidateUID,
			10,
			remark
		  );
		  if (response) {
			setAlert({
			  type: response.data.status,
			  message: response.data.message,
			});
			setShowModal(false);
		  } else {
			alert("Error Please Try After some time");
		  }
		} catch (error) {
		  setAlert({ type: "fail", message: error.response.data.message });
		}
	  };
	  Action();
	};

  // For Get System Remark
  const GetSystemRemark = () => {
    const Action = async () => {
      try {
        const response = await SystemRemark(
          selectedCandidate.submitedCandidateUID
        );
        if (response?.data?.status === "Success") {
          setSystemRemarkData(response.data.data);
          setShowSystemRemarkModal(true);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({
          type: "fail",
          message: error?.response?.data?.message || "Something went wrong",
        });
      }
    };
    Action();
  };

  // handle button for System Remark
  const handleViewSystemRemark = () => {
    GetSystemRemark();
    setShowSystemRemark(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setShowSystemRemark(false);
    setSystemRemarkData(null);
  };

  // Modal opens when clicked on Name
  const handleNameClick = (candidate) => {
    setSelectedCandidate(candidate);
    setShowModal(true);
  };

  return (
    <>
      <div className="jobs-container container mt-5 pt-5">
        <ToastContainer position="top-end" className="p-3">
          <Toast
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
            show={toast.show}
            delay={3000}
            autohide
          >
            <Toast.Body className="text-white fw-semibold">
              {toast.message}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        <div className="jobs-card shadow-sm">
          <div className="jobs-header d-flex justify-content-between align-items-center">
            <h3 className="fw-bold mb-0">Hold Candidates</h3>
          </div>

          {/* Search bar*/}
          <div className="jobs-toolbar d-flex flex-wrap align-items-center gap-3 my-3 w-100">
            <div
              className="input-group rounded-pill border bg-white shadow-sm"
              style={{ maxWidth: "350px" }}
            >
              <span className="input-group-text bg-transparent border-0 ps-3">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-0 rounded-5 shadow-none"
                placeholder="Search by name, title etc"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <div className="Overflow-Auto">
            {loading ? (
              <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
                <table className="table modern-table align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        Job Title
                        <i
                          className="bi bi-funnel ms-2 text-primary"
                          onClick={handleFilterIconClick}
                          style={{ cursor: "pointer" }}
                        ></i>
                      </th>
                      <th>Submited By</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        {Array(7)
                          .fill()
                          .map((__, i) => (
                            <td key={i}>
                              <Skeleton height={20} />
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </SkeletonTheme>
            ) : (
              <table className="table modern-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      Job Title
                      <i
                        className="bi bi-caret-down-fill mx-2"
                        onClick={handleFilterIconClick}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </th>
                    <th>Submited By</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCandidates.length > 0 ? (
                    currentCandidates.map((candidate, index) => (
                      <tr key={candidate.id || index}>
                        <td>{indexOfFirstCandidate + index + 1}</td>
                        <td>{candidate.jobTitel}</td>
                        <td>
                          {candidate.submitedBy}({candidate.submitByType})
                        </td>
                        <td>
                          <span
                            onClick={() => handleNameClick(candidate)}
                            className="text-primary fw-semibold"
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            {candidate.name || "-"}
                          </span>
                        </td>
                        <td>{candidate.email || "-"}</td>
                        <td>{candidate.mobile || "-"}</td>
                        <td style={{ fontSize: "1.5em" }}>
                          <i
                            className="bi bi-file-earmark-text text-primary"
                            onClick={() => {
                              if (candidate.resumePath) {
                                const url = viewResumeUrl(candidate.resumePath);
                                setResumeUrl(url);
                                setShowResumeModal(true);
                              } else {
                                alert("Resume not available.");
                              }
                            }}
                          ></i>
                          <div className="dropdown d-inline mx-3 position-relative">
                            <style>{`
                          .table-responsive {
                           overflow: visible !important;
                          }
                          .table-responsive .dropdown-menu {
                          z-index: 9999;
                          position: absolute !important;
                          transform: translate(0, 0) !important;
                          will-change: transform;
                          }
                          `}</style>

                            <i
                              className="bi bi-three-dots-vertical"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            ></i>

                            <ul className="dropdown-menu">
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "InterviewScheduled")
                                  }
                                >
                                  Schedule Interview
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "SelectedCandidate")
                                  }
                                >
                                  Select
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "RejectedCandidate")
                                  }
                                >
                                  Reject
                                </button>
                              </li>
							   <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "BackoutCandidate")
                                  }
                                >
                                  Back-out
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-danger py-3">
                        {hasCandidates
                          ? "No Candidate Found."
                          : "No Candidate Found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination */}
          {totalRecords > 10 && (
            <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
              <div className="d-flex align-items-center">
                <label className="me-2 fw-semibold">Items Per Page:</label>
                <Form.Select
                  className="form-select form-select-sm w-auto"
                  value={candidatesPerPage}
                  onChange={(e) => {
                    setCandidatesPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      <i class="bi bi-chevron-left"></i>
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${
                        currentPage === idx + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Job Title Filter Modal */}
          <Modal
            show={showJobTitleFilter}
            onHide={() => setShowJobTitleFilter(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Filter by Job Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Control
                type="text"
                placeholder="Search Job Titles"
                value={searchTitleText}
                onChange={handleSearchTitleChange}
                className="mb-2"
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedTitles.length === jobTitles.length}
                  onChange={(e) => handleSelectAllTitles(e.target.checked)}
                />
                <label className="form-check-label">Select All</label>
              </div>
              {filteredTitles.map((title, idx) => (
                <div className="form-check" key={idx}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedTitles.includes(title)}
                    onChange={() => handleSelectTitle(title)}
                    id={`job-title-${idx}`}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`job-title-${idx}`}
                  >
                    {title}
                  </label>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      {/* Resume View Modal */}
      <Modal
        show={showResumeModal}
        onHide={() => setShowResumeModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Candidate Resume</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {resumeUrl ? (
            <iframe
              src={resumeUrl}
              title="Resume"
              style={{ width: "100%", height: "100%", border: "none" }}
            ></iframe>
          ) : (
            <p>Resume not available.</p>
          )}
        </Modal.Body>
      </Modal>

      {/* --modal-- */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Candidate Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCandidate ? (
            <>
            <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center mb-3">
                    {/* Candidate Name */}
                    <h5 className="mb-0 text-uppercase text-primary me-2">
                      {selectedCandidate.name || "-NA-"}
                    </h5>

                    {/* Status Badge */}
                    {selectedCandidate.status && (
                      <span className="badge btn-primary text-white">
                        <i className="bi bi-activity me-1"></i>
                        {selectedCandidate.status}
                      </span>
                    )}
                  </div>

                  {/* System Remarks Button */}
                  <button
                    className="btn btn-sm fw-semibold"
                    // className="btn btn-sm btn-outline-primary"
                    onClick={handleViewSystemRemark}
                    style={{
                      background: "linear-gradient(45deg, #0D47A1, #42A5F5)",
                      color: "#fff",
                      padding: "4px 6px",
                    }}
                  >
                    {" "}
                    System Remark
                  </button>
                </div>

                <hr></hr>
                <div className="card-body">
                  {/* Other fields in 3 columns */}
                  <div className="row g-3">
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-envelope text-info me-1"></i>
                        Email
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.email
                          ? selectedCandidate.email
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-telephone text-info me-1"></i>
                        Mobile
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.mobile
                          ? selectedCandidate.mobile
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-briefcase text-info me-1"></i>
                        Job Title
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.jobTitel
                          ? selectedCandidate.jobTitel
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-person-badge text-info me-1"></i>
                        Submitted By
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.submitedBy} (
                        {selectedCandidate.submitByType})
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-people text-info me-1"></i>
                        Functional Manager
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.functionalManagerName} -{" "}
                        {selectedCandidate.functionalManager}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-person-workspace text-info me-1"></i>
                        Reporting Manager
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.reportingManagerName} -{" "}
                        {selectedCandidate.reportingManager}
                      </span>
                    </div>

                    {/* System Remark Section */}
                    {showSystemRemark &&
                      (systemRemarkData ? (
                        <div className="col-12 mt-2">
                          <h6 className="fw-bold text-primary mb-2 small">
                            <i className="bi bi-info-circle-fill me-1"></i>
                            Candidate Info
                          </h6>
                          <ul className="list-unstyled mb-2 small">
                            {systemRemarkData.candidateInfos.map(
                              (info, idx) => (
                                <li key={idx} className="mb-0">
                                  <i className="bi bi-check-circle-fill text-success me-1"></i>
                                  {info}
                                </li>
                              )
                            )}
                          </ul>
                          <hr></hr>
                          <h6 className="fw-bold text-primary mb-2 small">
                            <i className="bi bi-people-fill me-1"></i>Consultant
                            Info
                          </h6>
                          <div className="table-responsive">
                            <table className="table table-sm align-middle text-center table-hover mb-0">
                              <thead className="table-primary small">
                                <tr>
                                  <th>Status ID</th>
                                  <th>Status</th>
                                  <th>Total</th>
                                  <th>%</th>
                                </tr>
                              </thead>
                              <tbody>
                                {systemRemarkData.consultantInfo.map(
                                  (row, idx) => {
                                    let badgeClass = "bg-secondary";
                                    if (row.percentage < 20)
                                      badgeClass = "bg-danger";
                                    else if (row.percentage < 50)
                                      badgeClass = "bg-warning text-dark";
                                    else if (row.percentage < 80)
                                      badgeClass = "bg-info text-dark";
                                    else badgeClass = "bg-success";

                                    return (
                                      <tr key={idx} className="small">
                                        <td>{row.statusID}</td>
                                        <td>{row.status}</td>
                                        <td>{row.total}</td>
                                        <td>
                                          <span
                                            className={`badge ${badgeClass} px-2 py-1`}
                                          >
                                            {row.percentage}%
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                          <hr></hr>
                        </div>
                      ) : (
                        <p className="mt-2 text-muted fst-italic small">
                          No system remark data available.
                        </p>
                      ))}
                  </div>
                </div>
              </div>  
              {/* For Interview Scheduled Modal */}
              {modalType === "InterviewScheduled" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to schedule interview for this candidate?
                  </h6>

                  {/* Interview Date & Time */}
                  <input
                    type="datetime-local"
                    className="form-control w-50 mt-2"
                    value={interviewDateTime}
                    min={new Date().toISOString().slice(0, 16)}
                    onChange={(e) => setinterviewDateTime(e.target.value)}
                  />

                  {/* Remark */}
                  <textarea
                    placeholder="Enter remark..."
                    className="form-control mt-2"
                    style={{ minHeight: "80px", resize: "none" }}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleInterviewScheduleCandidate}
                    >
                      Schedule Interview
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
              {/* For Selected Candidate Modal */}
              {modalType === "SelectedCandidate" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to select this candidate?
                  </h6>

                  <textarea
                    placeholder="Enter remark..."
                    className="form-control mt-2"
                    style={{ minHeight: "80px", resize: "none" }}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleselectCandidate}
                    >
                      Select
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              {/* For Rejected Candidate Modal */}
              {modalType === "RejectedCandidate" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to reject this candidate?
                  </h6>
                  <textarea
                    placeholder="Enter remark..."
                    className="form-control mt-2"
                    style={{ minHeight: "80px", resize: "none" }}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleRejectedCandidate}
                    >
                      Reject
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

			  
							{/* For Back-out Candidate Modal */}
							{modalType === "BackoutCandidate" && (
							  <div className="p-3 rounded shadow-sm border bg-light">
								<h6 className="fw-semibold mb-2">
								  <i className="bi bi-exclamation-triangle text-warning me-2"></i>
								  Do you want to Back-out this candidate?
								</h6>
								<textarea
								  placeholder="Enter Remark"
								  className="form-control"
								  value={remark}
								  onChange={(e) => setRemark(e.target.value)}
								/>
			  
								<div className="d-flex justify-content-end gap-2 mt-3">
								  <Button
									variant="success"
									size="sm"
									className="px-3 border-0 btn-primary rounded-pill shadow-sm"
									onClick={HandleBackoutCandidate}
								  >
									Back-out
								  </Button>
								  <Button
									variant="outline-secondary"
									size="sm"
									className="px-3 rounded-pill"
									onClick={() => setShowModal(false)}
								  >
									{" "}
									Cancel
								  </Button>
								</div>
							  </div>
							)}
            </>
          ) : (
            <p>No candidate data selected.</p>
          )}
        </Modal.Body>
      </Modal>
      {/* --end modal-- */}

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};
export default GetHoldCandidate;
